import { Entity } from '@adornis/baseql/decorators.js';
import { Course } from './Course.js';

/**
 * @entity CourseLUS
 */
@Entity()
export class CourseLUS extends Course {
  public static override _class = 'CourseLUS';
}
